export const statCardStyles = {
  title: {
    color: 'rgb(145, 158, 171)',
    fontSize: '0.875rem',
    fontWeight: 600,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    mb: 0.5
  },
  valueContainer: {
    display: 'flex',
    alignItems: 'baseline',
    mb: 0.5
  },
  value: {
    color: 'rgb(255, 255, 255)',
    fontSize: '2.125rem',
    fontWeight: 700,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    lineHeight: 1.2,
    letterSpacing: '-0.5px'
  },
  change: (isPositive) => ({
    color: isPositive ? 'rgb(84, 214, 44)' : 'rgb(255, 72, 66)',
    fontSize: '0.875rem',
    fontWeight: 600,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    ml: 1
  }),
  period: {
    color: 'rgb(145, 158, 171)',
    fontSize: '0.875rem',
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    mb: 2
  }
}; 